import { Theme } from "@/enums";

interface IConfig {
  base_url_uz: 'https://test1api.boxette.uz/api/v1',
  base_url_ge: string;
  base_url_uk: string;
  external_boxette_uz: 'https://boxette.uz',
  external_boxette_ge: string;
  external_boxette_uk: string;
  send_parcel_url_ge: string;
}

export const config: IConfig = {
  base_url_uz: 'https://test1api.boxette.uz/api/v1',
  // base_url_ge: "https://test3api.boxette.ge/api/v1",
  base_url_ge: "https://test3api.boxette.ge/api/v1",
  send_parcel_url_ge: "https://profile1-stage.boxette.ge/api",
  // base_url_ge: "https://test1api.boxette.ge/api/v1",
  base_url_uk: "https://api-test.easyxpress.com.ua/api/v1",
  external_boxette_ge: "https://boxette.ge",
  external_boxette_uz: 'https://boxette.uz',
  external_boxette_uk: "https://easyxpress.com.ua",
};

export const GOOGLE_API_KEY_GE = "AIzaSyDx_otUmNoLQs7NpcQtpPYpDBDw54hd-j8";
export const GOOGLE_API_KEY_UZ = "AIzaSyCkEXvR4iplOqR6tg53HPcNIFsRYlYHDaE";
export const GOOGLE_API_KEY_UK = "AIzaSyCUZ32HafyHT7blTqDi2tzPvwy8otS5DlM";

export function getGoogleApiKey(theme: Theme | ""): string {
  // Use Georgia API key for Georgia theme
  if (theme === Theme.GEORGIA) {
    return GOOGLE_API_KEY_GE;
  }

  // Use UK API key for UK theme
  if (theme === Theme.UK) {
    return GOOGLE_API_KEY_UK;
  }

  // Use UZ API key for UZ theme and UK theme (fallback)
  return GOOGLE_API_KEY_UZ;
}

export const TERMS_LINK_UZ_RU = "https://boxette.uz/shippingterms";
export const TERMS_LINK_UZ_UZ = "https://boxette.uz/xizmatkorsatishshartlari";
export const TERMS_LINK_GE = "https://boxette.ge/shipping-terms";
export const TERMS_LINK_UK_EN =
  "https://easyxpress.com.ua/en/usloviya-obsluzhivaniya";
export const TERMS_LINK_UK_RU =
  "https://easyxpress.com.ua/usloviya-obsluzhivaniya";
export const TERMS_LINK_UK_UK =
  "https://easyxpress.com.ua/uk/usloviya-obsluzhivaniya";

export const SEND_PARCEL_ENABLED = false;
